import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Joins class names, letting later Tailwind classes override earlier ones
export function cx(...inputs) {
  return twMerge(clsx(inputs));
}
